import React from 'react'
import styled from 'styled-components'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { Message } from '../hooks/useStreamChat'

interface Props {
  message: Message
}

const ChatBubble: React.FC<Props> = ({ message }) => {
  const isUser = message.sender === 'user'

  return (
    <BubbleRow $isUser={isUser}>
      <Bubble $isUser={isUser}>
        <Sender $isUser={isUser}>{isUser ? 'Tú' : 'Piedad IA'}</Sender>
        <Text $isUser={isUser}>
          {isUser ? (message.text || '...') : <ReactMarkdown remarkPlugins={[remarkGfm]}>{message.text || '...'}</ReactMarkdown>}
        </Text>
      </Bubble>
    </BubbleRow>
  )
}

const BubbleRow = styled.div<{ $isUser: boolean }>`
  display: flex;
  justify-content: ${p => p.$isUser ? 'flex-end' : 'flex-start'};
`

const Bubble = styled.div<{ $isUser: boolean }>`
  max-width: 75%;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  background: ${p => p.$isUser
    ? 'linear-gradient(135deg, #98012E, #b5133f)'
    : 'rgba(255, 255, 255, 0.08)'};
  border: 1px solid ${p => p.$isUser
    ? 'rgba(152, 1, 46, 0.5)'
    : 'rgba(255, 255, 255, 0.1)'};
  color: #f1f1f1;
`

const Sender = styled.span<{ $isUser: boolean }>`
  display: block;
  font-size: 0.7rem;
  color: ${p => p.$isUser ? 'rgba(255,255,255,0.7)' : '#CA7C8E'};
  margin-bottom: 0.25rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

const Text = styled.div<{ $isUser: boolean }>`
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  word-break: break-word;

  p { margin: 4px 0; }
  h1, h2, h3 { margin: 8px 0 4px; }
  h2 { font-size: 1.1rem; }
  h3 { font-size: 1rem; }
  ul, ol { margin: 4px 0; padding-left: 20px; }
  table { border-collapse: collapse; width: 100%; margin: 8px 0; font-size: 0.85rem; }
  th, td { border: 1px solid rgba(255,255,255,0.2); padding: 4px 8px; text-align: left; }
  th { background: rgba(255,255,255,0.1); font-weight: 600; }
  strong { font-weight: 700; }
  code { background: rgba(255,255,255,0.1); padding: 2px 4px; border-radius: 3px; }
`

export default ChatBubble
